export default __webpack_public_path__ + "static/media/avatar-6.745013f0.jpg";